import {EntityManager} from "../engine/tools/EntityManager";
import {InteractiveCanvas} from "../engine/tools/InteractiveCanvas";
import {AppState} from "../app";

export async function initApp(globals: AppState) {


    globals.interactiveCanvas = new InteractiveCanvas("canvas", {
        visibleHeight: 600,
        backgroundColor: undefined
    })

    globals.entities = new EntityManager();
    globals.startupTimestamp = Date.now()

}

